module.exports = __webpack_public_path__ + "img/weddings_01_V.19cbc083.jpg";